module.exports = __webpack_public_path__ + "media/entities/6001-e07d49af.png";